export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 DinSexolog.dk. Alle rettigheder forbeholdes.</p>
    </footer>
  );
}